import { styled, keyframes } from "@pigment-css/react";
import { Divider } from "../../../primitives";

const shimmer = keyframes({
  "0%": { backgroundPosition: "-200px 0" },
  "100%": { backgroundPosition: "200px 0" },
});

const OuterWrapper = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.managementView.spacing[16],
}));

const MetricCardContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[16],
}));

const SkeletonElement = styled("div")(({ theme }) => ({
  borderRadius: theme.managementView.radius[10],
  background: `linear-gradient(90deg, ${theme.colors.neutral[200]} 0%, ${theme.colors.neutral[100]} 50%, ${theme.colors.neutral[200]} 100%)`,
  backgroundSize: "400px 100%",
  animation: `${shimmer} 1.5s ease-in-out infinite`,
}));

const LabelSkeleton = styled(SkeletonElement)({
  height: "14px",
  width: "60px",
});

const ValueSkeleton = styled(SkeletonElement)({
  height: "17px",
  width: "100px",
});

const ChipSkeleton = styled(SkeletonElement)(({ theme }) => ({
  height: "24px",
  width: "60px",
  borderRadius: theme.managementView.radius[16],
}));

export const CustomerMetricsSkeleton = () => {
  return (
    <>
      <OuterWrapper>
        <MetricCardContainer>
          <LabelSkeleton />
          <ValueSkeleton />
          <ChipSkeleton />
        </MetricCardContainer>
        <MetricCardContainer>
          <LabelSkeleton />
          <ValueSkeleton />
          <ChipSkeleton />
        </MetricCardContainer>
      </OuterWrapper>
      <Divider />
    </>
  );
};
